import { createContainer } from 'unstated-next'
import useSWR from 'swr'
import { useCallback, useState } from 'react'
import { uploadAssignmentSubmission } from '../../../../../../../../API/Course'

const LessonStore = createContainer(() => {
  const [config, setConfig] = useState()

  const { data, error, mutate } = useSWR(
    config
      ? config?.registrationId
        ? `/course/${config.courseId}/chapter/${config.chapterId}/lesson/${config.lessonId}?crId=${config.registrationId}`
        : `/course/${config?.courseId}/chapter/${config?.chapterId}/lesson/${config?.lessonId}`
      : null,
  )
  const saveResumeVideioLink = (url, config, course) => {
    console.log('hello')
    const data = JSON.parse(localStorage.getItem('resumeVideos')) || []
    const isCourseAlreadyExist = data.find(
      (item) => item.config.courseId === config.courseId,
    )
    let updatedData = []
    if (isCourseAlreadyExist) {
      updatedData = data.map((item) => {
        if (item.config.courseId === config.courseId) {
          return {
            url,
            config,
            course,
            time: new Date().getTime(),
          }
        }
        return item
      })
    } else {
      updatedData = [
        {
          url,
          config,
          course,
          time: new Date().getTime(),
        },
        ...data,
      ]
    }
    updatedData = updatedData.sort((a, b) => b.time - a.time)
    localStorage.setItem('resumeVideos', JSON.stringify(updatedData))
  }

  const saveAssignmentSubmission = useCallback(
    async (assignmentMediaUrl) => {
      const uploaded = await uploadAssignmentSubmission(
        config?.courseId,
        config?.chapterId,
        config?.lessonId,
        config?.registrationId,
        assignmentMediaUrl,
      )
      if (uploaded) {
        await mutate()
      }
    },
    [config, mutate],
  )

  return {
    loading: !data,
    loadFailed: Boolean(error),
    data,
    config,
    setConfig,
    saveAssignmentSubmission,
    saveResumeVideioLink,
  }
})

export default LessonStore
